import "./PrivateItinerary.scss";
import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Dropdown from 'react-bootstrap/Dropdown';
import infoIcon from '../../../../../assets/images/info-icon.png';
import pdfImg from "../../../../../assets/images/pdf.png";
import WhiteArrowIcon from '../../../../../assets/images/white-arrow.png';
import noPictureAvailable from '../../../../../assets/images/no-picture-available.jpg';
import { addItineraryItemRequestApi, getAllItineraryApi } from "../../../../../services/CmsService";
import { useAuth } from "../../../../../contexts/AuthProvider";
import { imageUrlOthers } from "../../../../../services/CommonUrl";
import { getCityWiseItinerary, getCountryWiseItinerary, getDateWiseItinerary, getDaysWiseItinerary, getPriceWiseItinerary, getRatingWiseItinerary, getTravellersWiseItinerary, sortWiseItinerary } from "../../../../../helpers/ItineraryFilter";
import { PrivateItineraryPlaceholder } from "../../../../../components/skeleton-placeholder";
import { NoDataFound } from "../../../../../components/no-data-found";
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import { collectIcons, findMinMaxAmount } from "../../../../../helpers";
import WarningModal from "../../../../../components/warning-modal";
import { LoadingSpinnerDotted } from "../../../../../components/loading-spinner/Loader";


const PrivateItinerary = ({
    filters,
    setFilters,
    setTotalItinerary,
    perPageChange,
    paginationChange,
    sizePaginate,
    currentPaginate,
    setDefaultMaxPrice
}) => {

    const { authed, currencyData } = useAuth();
    const history = useHistory();
    const isPDF = (file) => /\.pdf$/i.test(file);
    const [isLoading, setIsLoading] = useState(false);
    const [itineraryPrivateData, setItineraryPrivateData] = useState([]);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [message, setMessage] = useState("");

    const handlePrivateItemInfo = (data, e) => {
        privateItemFromik.setValues({
            ...privateItemFromik.values,
            userId: authed?.user?._id,
            itineraryId: data._id
        });
    }
    const privateItemFromik = useFormik({
        initialValues: {
            name: "",
            email: "",
            phone: "",
            itineraryId: "",
            userId: ""
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            name: Yup.string()
                .max(20, 'Name should not exceed 20 Characters.')
                .required('Please Enter Name.'),
            email: Yup.string()
                .email('Invalid email address.')
                .required('Please enter email address.'),
        }),
        onSubmit: values => {
            // console.log('Private value:', values);
            addItineraryItemRequestApi(values, async (res) => {
                // console.log('addItineraryRequestApi:', res?.data);
                if (res.status === 200) {
                    setMessage(res?.data?.message);
                    setShowWarningModal(true);
                    privateItemFromik.resetForm();
                } else {
                    console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                }
            });
        }
    });

    const handleToggleDrp = (tgl) => {
        const isdrp = tgl;
        if (isdrp === false) {
            privateItemFromik.resetForm();
        }
    }
    const getPrivateItineraryData = async () => {
        setIsLoading(true);
        await getAllItineraryApi({
            type_of_itinerary: "Private",
            newCurrency: currencyData?.currency
        }, async (res) => {
            setIsLoading(false);
            // console.log("res getAllItineraryApi ====", res);
            if (res.status === 200) {
                if (res?.data?.success) {
                    const result = res?.data?.data?.sort((a, b) => new Date(a.updatedAt) < new Date(b.updatedAt) ? 1 : -1);
                    const maxValue = findMinMaxAmount(result);
                    setItineraryPrivateData(result);
                    setDefaultMaxPrice(maxValue);
                    setFilters((prev) => ({
                        ...prev,
                        priceRange: { ...prev.priceRange, max: maxValue }
                    }));
                }
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    const ImagesComponent = ({ data }) => {
        const imagesArr = collectIcons(data);
        return (
            <div className="int-img-badge">
                {imagesArr?.length === 0 ? (
                    <span>
                        <img
                            src={noPictureAvailable}
                            alt={"No Picture Available"}
                        />
                    </span>
                ) : (
                    imagesArr.map((dtitem, index) => {
                        return (
                            <>
                                <span key={index}>
                                    {dtitem === null ? (
                                        <img
                                            src={noPictureAvailable}
                                            alt={"No Picture Available"}
                                        />
                                    ) : (
                                        <img
                                            src={isPDF(dtitem) ? pdfImg : imageUrlOthers + dtitem}
                                            alt={dtitem || "No Picture Available"}
                                        />
                                    )}
                                </span>
                            </>
                        )
                    })
                )
                }
            </div>
        )
    };

    const priceWiseItinerary = getPriceWiseItinerary(itineraryPrivateData, filters.priceRange);
    const daysWiseItinerary = getDaysWiseItinerary(priceWiseItinerary, filters.dayRange);
    const ratingWiseItinerary = getRatingWiseItinerary(daysWiseItinerary, filters.travellerRating);
    const travellerTypeWiseItinerary = getTravellersWiseItinerary(ratingWiseItinerary, filters.travellerType);
    const datesWiseItinerary = getDateWiseItinerary(travellerTypeWiseItinerary, filters.dateRange);
    const countryWiseItinerary = getCountryWiseItinerary(datesWiseItinerary, filters.country);
    const cityWiseItinerary = getCityWiseItinerary(countryWiseItinerary, filters.city);
    const Itineraries = sortWiseItinerary(cityWiseItinerary, filters.sortType);

    // console.log("Private Itinerary", Itineraries);

    useEffect(() => {
        getPrivateItineraryData();
    }, []);

    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    {isLoading ? (
                        <PrivateItineraryPlaceholder count={sizePaginate} />
                    ) : (
                        <>
                            {setTotalItinerary(Itineraries?.length || 0)}
                            {Itineraries?.length > 0 ?
                                <ul className="private-itineraries-ul">
                                    {Itineraries?.length > 0 && Itineraries?.slice((currentPaginate - 1) * sizePaginate, currentPaginate * sizePaginate).map((item, i) => {
                                        return (
                                            <>
                                                <li key={item._id}>
                                                    <p>Someone built a <span>{item?.destinationCityDetails.reduce((accumulator, current) => accumulator + current.itineraryDatys.length, 0)} Days</span> itinerary {item.destinationCityDetails[0].from_city.city} to {item.destinationCityDetails[0].destination_city.city}. </p>
                                                    <div className="pint-right">
                                                        <ImagesComponent data={item?.destinationCityDetails} />
                                                        {authed?.isAuth === true ?
                                                            <Dropdown className="int-btn-dropdown" onToggle={(isOpen) => handleToggleDrp(isOpen)} onClick={(e) => handlePrivateItemInfo(item, e)}>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={<Tooltip className="customTooltip">Click here to know more</Tooltip>}
                                                                >
                                                                    <Dropdown.Toggle className="int-btn-info">
                                                                        <img src={infoIcon} alt="Info icon" />
                                                                    </Dropdown.Toggle>
                                                                </OverlayTrigger>
                                                                <Dropdown.Menu className="int-dropdown">
                                                                    <form onSubmit={privateItemFromik.handleSubmit}>
                                                                        <div className="int-input-field">
                                                                            <input onChange={privateItemFromik.handleChange} onBlur={privateItemFromik.handleBlur} value={privateItemFromik.values.name} name="name" className="form-control" type="text" placeholder="Your Name" />
                                                                            {privateItemFromik.touched.name && privateItemFromik.errors.name ? <span className="errors-msg">{privateItemFromik.errors.name}</span> : null}
                                                                        </div>
                                                                        <div className="int-input-field mrt-15">
                                                                            <input onChange={privateItemFromik.handleChange} onBlur={privateItemFromik.handleBlur} value={privateItemFromik.values.email} name="email" className="form-control" type="email" placeholder="Your Email" />
                                                                            {privateItemFromik.touched.email && privateItemFromik.errors.email ? <span className="errors-msg">{privateItemFromik.errors.email}</span> : null}
                                                                        </div>
                                                                        <div className="int-input-field mrt-15">
                                                                            <input onChange={privateItemFromik.handleChange} value={privateItemFromik.values.phone} name="phone" className="form-control" type="text" placeholder="Phone Number" />
                                                                        </div>
                                                                        <div className="int-input-field mrt-20 text-center">
                                                                            <button disabled={!(privateItemFromik.isValid && privateItemFromik.dirty) || privateItemFromik.isSubmitting} type="submit" className="btn btn-primary-color ">
                                                                                {privateItemFromik.isSubmitting ? (
                                                                                    <LoadingSpinnerDotted />
                                                                                ) : (
                                                                                    <>Submit <img src={WhiteArrowIcon} alt="" /></>
                                                                                )}
                                                                            </button>
                                                                        </div>
                                                                    </form>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                            :
                                                            <div className="int-btn-dropdown">
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={<Tooltip className="customTooltip">Click here to know more</Tooltip>}
                                                                >
                                                                    <button className="btn int-btn-info" onClick={() => history.push("/signin")}>
                                                                        <img src={infoIcon} alt="Info icon" />
                                                                    </button>
                                                                </OverlayTrigger>
                                                            </div>}
                                                    </div>
                                                </li>
                                            </>
                                        )
                                    })}
                                </ul>
                                :
                                <NoDataFound text="No itinerary found" />
                            }
                        </>
                    )}
                    <Pagination
                        className="pagination-style text-end mt-4"
                        showTitle={false}
                        showTotal={(total, range) => `Showing ${range[0]} - ${range[1]} itineraries of ${total} itineraries`}
                        onChange={paginationChange}
                        total={Itineraries?.length || 0}
                        current={currentPaginate}
                        pageSize={sizePaginate}
                        showSizeChanger={false}
                        onShowSizeChange={perPageChange}
                        hideOnSinglePage={true}
                    />
                </div>
            </div>
            <WarningModal
                type={"KnowMorePrivate"}
                message={message}
                showWarningModal={showWarningModal}
                setShowWarningModal={setShowWarningModal}
                isLoading={""}
            />
        </>
    )
};

export default PrivateItinerary;